import React, {RefObject} from 'react';

interface TabsContext {
  selectedTab: number;
  setSelectedTab: (newTab: number) => void;
  tabsRef: RefObject<HTMLButtonElement[]>;
  size: 'sm' | 'md';
  isLazy?: boolean;
  id: string;
}

export const TabContext = React.createContext<TabsContext>(null!);
